import { Component, Input, SimpleChanges } from '@angular/core';
import { IRptDtxPay } from '../../../shared/interfaces/rptDtx';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-rpt-dtx-payment',
  imports: [],
  templateUrl: './rpt-dtx-payment.component.html',
  styleUrl: '../rpt-dtx.component.css',
  standalone: false
})
export class RptDtxPaymentComponent {
  @Input() payment: IRptDtxPay[];
  @Input() engLang: boolean;

  dataSource: MatTableDataSource<IRptDtxPay> = new MatTableDataSource<IRptDtxPay>();
  displayedColumns: string[] = [
    'payAmnt',
    'payPS',
    'payMode',
    'payCkNo',
    'payMemo'
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['payment'] && this.payment) {
      this.dataSource.data = this.payment.slice(); // Create a new array to avoid reference issues
    }
  }

  makeNum(value: number | string): number {
    return Number(value.toString().replace(/,/g, '')); // Convert string with commas to number
  }

}
